import { useTranslation } from 'react-i18next';

export const useTranslationThroughKey = (namespace: string, mainKey: string) => {
  const { t: originalT } = useTranslation(namespace);
  const t = (key: string, replacements?: { [key: string]: string }) => originalT(`${mainKey}.${key}`, replacements);
  return t;
};
